if (!customElements.get('configurator-add-ons')) {
    customElements.define('configurator-add-ons', class ConfiguratorAddOns extends HTMLElement {
        constructor() {
            super();
            const viewer = document.querySelector('[id^="GalleryViewer"]');
            this.elements = this.querySelectorAll('[data-add-on-id]');
            this.elements.forEach((element) => {
                element.addEventListener('change', (event) => this.layerImage(event, element.dataset.addOnId, viewer));
            }
            );
        }
        layerImage(event, mediaID, viewer) {
            const activeMedia = viewer.querySelectorAll(`[data-add-on-media-id="${mediaID}"]`);
            const productMediaItems = document.querySelectorAll('[data-sel-open-image]');
            const checkbox = event.target;
            activeMedia.forEach((item) => {
                if (checkbox.checked) {
                    item.classList.add('is-active');
                } else {
                    item.classList.remove('is-active');
                }
            });
            if (checkbox.hasAttribute('data-item-handle') && checkbox.getAttribute('data-item-handle') === "full-tote-upgrade") {
                if (checkbox.checked) {
                    productMediaItems.forEach(function (productMediaItem) {
                        productMediaItem.setAttribute('data-sel-open-image', 'true');
                        let childImage = productMediaItem.querySelector('img');
                        if (childImage) {
                            childImage.classList.add('z-index-custom'); // Add your desired class here
                        }
                    });
                } else {
                    productMediaItems.forEach(function (productMediaItem) {
                        productMediaItem.setAttribute('data-sel-open-image', 'false');
                        let childImage = productMediaItem.querySelector('img');
                        if (childImage) {
                            childImage.classList.remove('z-index-custom'); // Remove the class if necessary
                        }
                    });
                }
            }            
        };
    });
}

